/**
 * Ukrainian hryvnia.
 */
export var UAH = {
  code: 'UAH',
  base: 10,
  exponent: 2
};